import adsSaga from './ads.saga'
import citySaga from './city.saga'

export default [...citySaga, ...adsSaga]
